type SessionExpiredHandler = () => void | Promise<void>;

let sessionExpiredHandler: SessionExpiredHandler | null = null;
let hasNotifiedSessionExpiry = false;

export const setSessionExpiredHandler = (
  handler: SessionExpiredHandler | null
) => {
  sessionExpiredHandler = handler;
};

export const resetSessionExpiryNotification = () => {
  hasNotifiedSessionExpiry = false;
};

export const notifySessionExpired = () => {
  if (hasNotifiedSessionExpiry) return;

  hasNotifiedSessionExpiry = true;
  if (sessionExpiredHandler) {
    void sessionExpiredHandler();
  }
};
